// src/lib/formatTime.ts
//
// Format ISO timestamps from the .NET agent as local-time strings.
//
// The agent serializes DateTime.UtcNow WITHOUT a timezone suffix
// (e.g. "2026-05-26T00:13:53.145279"). The JS Date constructor treats
// such bare strings as LOCAL time, so a UTC timestamp displayed
// directly is off by the user's UTC offset. We always append 'Z' when
// the string carries no timezone so the parse interprets it as UTC,
// then toLocaleString() renders it in the browser's timezone.
//
// Supabase columns of type TIMESTAMPTZ come back with a timezone
// suffix (`+00:00` or `Z`) so the regex check skips the fix-up there.

export function fmtLocalTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const hasTz = iso.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(iso);
  const d = new Date(hasTz ? iso : iso + 'Z');
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString();
}

/** Same but returns a fallback when input is null/undefined/invalid. */
export function fmtLocalTimeOr(iso: string | null | undefined, fallback: string): string {
  const out = fmtLocalTime(iso);
  return out || fallback;
}
